import { AHSeparator, AHText, Box, useTheme } from "arkh";
import React from "react";
import { ActivityIndicator } from "react-native";
import { HeaderButton } from "../../../../components";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export function WidgetSettingsHeader(props: {
  onClose: () => void;
  onDone?: () => void;
  disabled?: boolean;
  loading?: boolean;
  title: string;
  dirty: boolean;
}) {
  const theme = useTheme();
  const height = 44;
  const insets = useSafeAreaInsets();
  return (
    <Box insets={{ top: insets.top }} color="surface-primary">
      <Box
        style={{
          height,
          width: "100%",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <AHText
          type="title-small"
          style={{
            flex: 1,
            textAlign: "center",
            left: 0,
            top: 0,
            width: "100%",
          }}
        >
          {props.title}
        </AHText>
        <Box
          style={{
            position: "absolute",
            justifyContent: "center",
            top: 0,
            left: 0,
            height,
          }}
          spaceHorizontal="medium"
        >
          <HeaderButton
            type={props.dirty ? "CANCEL" : "CLOSE"}
            onPress={props.onClose}
          />
        </Box>
        {props.onDone && props.dirty ? (
          <Box
            style={{
              position: "absolute",
              justifyContent: "center",
              top: 0,
              right: 0,
              height,
            }}
            spaceHorizontal="medium"
          >
            {props.loading ? (
              <ActivityIndicator color={theme.primary} />
            ) : (
              <HeaderButton
                onPress={props.onDone}
                disabled={props.disabled}
                type="SAVE"
              />
            )}
          </Box>
        ) : null}
      </Box>
      <AHSeparator />
    </Box>
  );
}
